import { Body } from '@casavo/habitat'
import cn from 'classnames'
import useTranslation from 'next-translate/useTranslation'
import getConfig from 'next/config'
import Image from 'next/image'

import Icon from '@/components/Icon'
import { useCurrentTenant } from '@/context/TenantProvider'
import { TENANTS } from '@/lib/tenants/constants'

import { priorityAlreadyBookedButton } from './styles.css'

export const AlreadyBookedBanner = (props) => {
  const { t } = useTranslation()
  const tenant = useCurrentTenant()
  const {
    publicRuntimeConfig: { imageBasePath },
  } = getConfig()

  return (
    <div className={cn(priorityAlreadyBookedButton, props.className)}>
      {tenant === TENANTS.casavo && <Icon.Clock />}
      {tenant === TENANTS.ucsc && (
        <Image alt="tick" height={20} src={`${imageBasePath}/images/tenants/ucsc/single-tick.svg`} width={20} />
      )}
      <Body noMargin strong size="m">
        {t('priority:PriorityDetail_FloatingBanner_Booked_CTA')}
      </Body>
    </div>
  )
}
